export default [
  {
    vid: "01",
    name: "Test1",
    senderID: "1q2we4",
    submitted: "2021-11-10 13:36:24",
    status: "Approved",
  },
  {
    vid: "02",
    name: "Test2",
    senderID: "1q2we4",
    submitted: "2021-11-10 13:36:24",
    status: "Approved",
  },
];
